import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';

const styles = css`
  background-image: url('/images/detail-header-bg.jpg');
  background-size: auto 300px;
  background-position: top center;
  background-repeat: no-repeat;
  height: auto;
  padding: 300px 0 0 0;
  width: 100%;
  position: relative;
  z-index: 2;
  @media (min-width: 992px) {
    height: 75vh;
    padding: 0;
    background-size: cover;
    background-position: center center;
  }
`;

function DetailHeaderWrapper({ className, children, imageUrl }) {
  let mergedStyles = cx(styles, className);
  if (imageUrl) {
    const imageCss = css(`background-image: url('${buildThumbnailUrl(imageUrl, { width: 2000, height: 2000 })}');`);
    mergedStyles = cx(mergedStyles, imageCss);
  }
  return (
    <div
      className={mergedStyles}
    >
      {children}
    </div>
  );
}

DetailHeaderWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  imageUrl: PropTypes.string,
};

DetailHeaderWrapper.defaultProps = {
  className: undefined,
  imageUrl: undefined,
};

export default DetailHeaderWrapper;



// WEBPACK FOOTER //
// ./src/components/DetailHeaderWrapper.js